import Image from "next/image";

import { useCategorySlider } from "../../hooks/useCategorySlider";
import CategoriesSwipper from "./CategoriesSwiper";
import { FestivalCategory } from "@features/landing/types";

interface Props {
  data?: FestivalCategory[];
}

const FestivalCategoriesSlider: React.FC<Props> = ({ data = [] }) => {
  const { handleClear, handleSelect, isMobile, currentCategory } =
    useCategorySlider();

  return (
    <section className="mb-6 sm:mb-14 sm:-mt-20 sm:px-8">
      <div className="relative mx-auto bg-white shadow-md sm:rounded-lg xl:max-w-[1204px] sm:px-6 sm:py-8 py-0">
        <div className="absolute inset-0 z-[1] hidden overflow-hidden opacity-5 sm:block sm:rounded-lg">
          <Image
            src="https://faradars.org/wp-content/uploads/2024/04/30/festival-all-category-bg.png"
            alt="festival background"
            fill
            className="object-cover"
            priority={false}
          />
        </div>

        <CategoriesSwipper
          isMobile={isMobile}
          handleClear={handleClear}
          data={data}
          handleSelect={handleSelect}
          activeCategoryId={Number(currentCategory)}
        />
      </div>
    </section>
  );
};

export default FestivalCategoriesSlider;
